/**
 * Brand is a build-time singleton (`NEXT_PUBLIC_BRAND`, its own deployment per brand), so this is
 * resolved once at module load. No `brandConfig`/`_app` import → no circular-import risk, usable in
 * hooks AND standalone push functions.
 */
export const IS_QUALITYLODGINGS = process.env.NEXT_PUBLIC_BRAND === 'qualitylodgings';

/**
 * qualitylodgings-only GTM event names. For qualitylodgings these 8 events are the ONLY events that
 * fire — all legacy GA4 `ecommerce`/`squeezelyProducts` events are suppressed (see the emitters in
 * `utils/analytics/qualitylodgingsEvents.ts` and the per-hook `IS_QUALITYLODGINGS` guards). For every
 * other brand none of these fire and the legacy events are emitted unchanged.
 */
export const QL_EVENTS = {
    selectRoom: 'select_room',
    viewRoom: 'view_room',
    viewHotelBe: 'view_hotel_be',
    startCheckout: 'start_checkout',
    viewGuestData: 'view_guest_data',
    viewSummary: 'view_summary',
    bookingComplete: 'booking_complete',
    searchAvailabilityBe: 'search_availability_be',
} as const;
